var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerifyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16659 1.63289C7.62659 1.23956 8.37992 1.23956 8.84659 1.63289L9.89992 2.53956C10.0999 2.71289 10.4733 2.85289 10.7399 2.85289H11.8733C12.5799 2.85289 13.1599 3.43289 13.1599 4.13956V5.27289C13.1599 5.53289 13.2999 5.91289 13.4733 6.11289L14.3799 7.16622C14.7733 7.62622 14.7733 8.37956 14.3799 8.84622L13.4733 9.89956C13.2999 10.0996 13.1599 10.4729 13.1599 10.7396V11.8729C13.1599 12.5796 12.5799 13.1596 11.8733 13.1596H10.7399C10.4799 13.1596 10.0999 13.2996 9.89992 13.4729L8.84659 14.3796C8.38659 14.7729 7.63325 14.7729 7.16659 14.3796L6.11325 13.4729C5.91325 13.2996 5.53992 13.1596 5.27325 13.1596H4.11992C3.41325 13.1596 2.83325 12.5796 2.83325 11.8729V10.7329C2.83325 10.4729 2.69325 10.0996 2.52659 9.89956L1.62659 8.83956C1.23992 8.37956 1.23992 7.63289 1.62659 7.17289L2.52659 6.11289C2.69325 5.91289 2.83325 5.53956 2.83325 5.27956V4.13289C2.83325 3.42622 3.41325 2.84622 4.11992 2.84622H5.27325C5.53325 2.84622 5.91325 2.70622 6.11325 2.53289L7.16659 1.63289Z",
    fill: "#6AC5FC",
    stroke: "#6AC5FC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58659 8.00005L7.19326 9.61339L10.4133 6.38672",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyIcon);
export default __webpack_public_path__ + "static/media/verify-icon.b416980f88cfa333bf4714f336bea984.svg";
export { ForwardRef as ReactComponent };